export default __webpack_public_path__ + "static/media/learn-more-card-ddl.3b47896b.svg";